var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "grid-container",
    { staticClass: "appraisal-container" },
    [
      _c("p", [
        _vm._v(
          "This online Assessment Tool is an opportunity for you to showcase your skills and knowledge and to better determine your fit for the position."
        )
      ]),
      _c("p", [
        _vm._v(
          "As part of the process you will be required to participate in two assessment tests."
        )
      ]),
      _c("br"),
      _c("h5", [
        _c("u", [
          _vm._v("Please follow the instructions below before you proceed:")
        ])
      ]),
      _c("ul", [
        _c("li", [
          _vm._v("You have "),
          _c("b", [_vm._v("1 Hour and 30 Minutes")]),
          _vm._v(" to complete "),
          _c("b", [_vm._v("both")]),
          _vm._v(" Assessments")
        ]),
        _c("li", [
          _vm._v(
            "You can view a countdown of your available time at the top of the screen."
          )
        ]),
        _c("li", [
          _vm._v("Once you begin the Assessment, "),
          _c("b", [_vm._v("you cannot stop or pause it")]),
          _vm._v(
            " - so please make sure you have allocated enough time to successfully complete the assessments."
          )
        ]),
        _c("li", [
          _vm._v(
            "Once you finish the first assessment, the countdown timer will continue running so please make sure you begin the second assessment as soon as you can."
          )
        ]),
        _c("li", [
          _vm._v(
            "Try to keep distractions at a minimum while undergoing the assessment; such as closing all programs, including email."
          )
        ]),
        _c("li", [
          _vm._v(
            "Once you provide your response, you will not be allowed to go back and change your answer - so please make sure you are confident with your response before continuing with the next question."
          )
        ]),
        _c("li", [
          _vm._v(
            "You will need a stable internet connection to take part in the assessment."
          )
        ]),
        _c("li", [
          _c("b", [_vm._v("Calculators or Mobile Phones are not permitted.")])
        ])
      ]),
      _c("br"),
      _c("h5", [_c("u", [_vm._v("During the Assessment:")])]),
      _c("p", [
        _vm._v(
          "As part of the assessment process, you will be shown various questions and problems that you need to answer."
        )
      ]),
      _c("p", [
        _vm._v("For each question you have four (4) possible options.")
      ]),
      _c("p", [
        _vm._v(
          "In order to provide your response and move on to the next question; you will be required to provide "
        ),
        _c("b", [_vm._v("one (1) response")]),
        _vm._v(" for each question.")
      ]),
      _c("p", [
        _vm._v(
          "Once you submit your response, you may proceed onto the next question"
        )
      ]),
      _c("br"),
      _c("h5", [_c("u", [_vm._v("Support")])]),
      _c("p", [
        _vm._v("If you have any questions, please contact us at "),
        _c(
          "a",
          { staticClass: "link", attrs: { href: "mailto:info@owiwi.co.uk" } },
          [_vm._v("info@owiwi.co.uk")]
        ),
        _vm._v(" and we will be happy to help!")
      ]),
      _c("p", [
        _c("b", [
          _vm._v(
            "To begin the Assessment, click on “" +
              _vm._s(_vm.$t("TakeTheTest")) +
              "” below."
          )
        ])
      ]),
      _c("br"),
      _c("p", [_c("b", [_vm._v("Best of Luck!")])]),
      _c("br"),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.openDialog } },
        [_vm._v("\n      " + _vm._s(_vm.$t("TakeTheTest")) + "\n    ")]
      ),
      _c(
        "ElDialog",
        {
          attrs: {
            "append-to-body": "",
            title: "Are You Sure?",
            "custom-class": "dialog-size-550",
            visible: _vm.confirmDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.confirmDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("p", [
              _vm._v(
                "This is a timed assessment with one and a half hours available.\nOnce you begin, you will not be able to pause or stop the process.\nAre you sure you are ready to begin?"
              )
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "ElButton",
                {
                  attrs: { type: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.confirmDialog = false
                    }
                  }
                },
                [_vm._v("\n          No\n        ")]
              ),
              _c(
                "ElButton",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.startTest()
                    }
                  }
                },
                [_vm._v("\n          Yes\n        ")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "ElDialog",
        {
          attrs: {
            "append-to-body": "",
            title: "Select Language",
            "custom-class": "dialog-size-550",
            visible: _vm.selectLang
          },
          on: {
            "update:visible": function($event) {
              _vm.selectLang = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.language,
                    callback: function($$v) {
                      _vm.language = $$v
                    },
                    expression: "language"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "en" } }, [
                    _vm._v("English")
                  ]),
                  _c("el-radio-button", { attrs: { label: "el" } }, [
                    _vm._v("Ελληνικά - Greek")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "ElButton",
                {
                  attrs: { type: "primary", disabled: !_vm.language },
                  on: {
                    click: function($event) {
                      return _vm.selectLanguage()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("TakeTheTest")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }